import './index.scss';
import { Link,NavLink } from 'react-router-dom';
import LogoS from '../../assets/images/logo-s.png'
// import LogoSubtitle from '../../assets/images/logo_sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose, faEnvelope, faHome, faUser } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { useState } from 'react';

const Sidebar = () => {
    const [showNav, setShowNav] = useState(false);
    return (
        <div className='nav-bar'>
            <Link className='logo' to="/">
                <img src={LogoS} alt='logo' />
                {/* <img className='sub-logo' src={LogoSubtitle} alt='ayush' /> */}
                <span className='sub-logo'>Ayush</span>
            </Link>
            <nav className={showNav ? 'mobile-show' : ''}>
                <NavLink onClick={()=>{setShowNav(false)}} exact="true"  to="/" >
                    <FontAwesomeIcon icon={faHome} color="#4d4d4e"/>
                </NavLink>
                <NavLink onClick={()=>{setShowNav(false)}} exact="true" className="about-link" to="/about" >
                    <FontAwesomeIcon icon={faUser} color="#4d4d4e"/>
                </NavLink>
                <NavLink onClick={()=>{setShowNav(false)}} exact="true" className="contact-link" to="/contact" >
                    <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e"/>
                </NavLink>
                <FontAwesomeIcon onClick={()=>{setShowNav(false)}} icon={faClose} color='#CB0723' size='3x' className='close-icon'/>
            </nav>
            <ul>
                <li>
                    <a target="__blank" rel='noreferrer' href='https://www.linkedin.com/in/ayush-kumar-3519a61bb/'>
                        <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e"/>
                    </a>
                </li>
                <li>
                    <a target="__blank" rel='noreferrer' href='https://www.linkedin.com/in/ayush-kumar-3519a61bb/'>
                        <FontAwesomeIcon icon={faGithub} color="#4d4d4e"/>
                    </a>
                </li>
            </ul>
            <FontAwesomeIcon onClick={()=>{setShowNav(true)}} icon={faBars} color='#CB0723' size='3x' className='hamburger-icon'/>
        </div>
    )
};
export default Sidebar;